import { createRoot } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import App from './App';
import '../scss/admin.scss';

const ImageCleanerAdmin = () => {
    return (
        <div>
            <App />
        </div>
    );
};

const root = createRoot(document.getElementById('media-trim-admin'));
root.render(<ImageCleanerAdmin />);
